// Audit 2026-09-27 L4: the login page said "Please check your credentials" on EVERY
// failure, including 500s — 25 "System error" sign-ins on 2026-09-05 were each told
// their password was wrong. Pick the message from the HTTP status.

export function loginFailureMessage(status: number | undefined, serverMessage?: string): string {
  if (status === 401) return 'Please check your email and password and try again.';
  if (status === 429) return serverMessage || 'Too many sign-in attempts. Please wait a while and try again.';
  if (status === undefined || status === 0 || status >= 500) {
    return "We couldn't reach the sign-in service. Please try again in a moment.";
  }
  return serverMessage || 'Sign-in failed. Please try again.';
}
